import { ICartData } from '@features/cart/typescript';
const RTBHouseAddToCart = (products: ICartData[]) => {
  products.forEach((product: ICartData) => {
    if (window?.rtbhEvents && Array.isArray(window.rtbhEvents)) {
      window.rtbhEvents.push({
        eventType: 'basketadd',
        productName: product?.name,
        productId: product?.productId,
        quantity: product?.quantity
      });
    }
  });
};
export default RTBHouseAddToCart;